<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-show="showCalendar"
        v-bind:filterDateOverride="onFilterDateOverride"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: 'parkinglicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${dataItem.parkinglicense}</a>`;
    },
  },
  {
    key: 'customer',
    text: 'Customer Name',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      }
    },
  },
  {
    key: 'season',
    text: 'Product Name',
  },
  {
    key: 'seasonTenant',
    text: 'Tenant Type',
  },
  {
    key: 'Reserved passcard',
    text: 'RESERVED<br>Passes',
  },
  {
    key: 'Reserved rate',
    text: 'RESERVED<br>Rate',
  },
  {
    key: 'Reserved value',
    text: 'RESERVED<br>Value',
  },
  {
    key: 'Non-Reserved passcard',
    text: 'NON-RESERVED<br>Passes',
  },
  {
    key: 'Non-Reserved rate',
    text: 'NON-RESERVED<br>Rate',
  },
  {
    key: 'Non-Reserved value',
    text: 'NON-RESERVED<br>Value',
  },
  {
    key: 'Tandem-Reserved passcard',
    text: 'TANDEM-RESERVED<br>Passes',
  },
  {
    key: 'Tandem-Reserved rate',
    text: 'TANDEM-RESERVED<br>Rate',
  },
  {
    key: 'Tandem-Reserved value',
    text: 'TANDEM-RESERVED<br>Value',
  },
  {
    key: 'Motorcycle passcard',
    text: 'MOTORBIKE<br>Passes',
  },
  {
    key: 'Motorcycle rate',
    text: 'MOTORBIKE<br>Rate',
  },
  {
    key: 'Motorcycle value',
    text: 'MOTORBIKE<br>Value',
  },
  {
    key: 'total passcard',
    text: 'TOTAL<br>Passes',
  },
  {
    key: 'total value',
    text: 'TOTAL<br>Value',
  },
  {
    key: 'remark',
    text: 'REMARKS',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportCustomerFees",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Customer Fees' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
      showCalendar: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    onFilterDateOverride(component, start, end) {
      let diffInDays = end.diff(start, 'days');
      if(diffInDays > 31) {
        end = new moment(start).add(start.daysInMonth() - 1, 'days').endOf('days')
        component.setEndDate(end)
      }
      component.$emit('filter-data-change', start, end);
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.showCalendar = true;
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.showCalendar = true;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      let feedbackItem = 'car park product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadCustomer();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomer() {
      let feedbackItem = 'customer data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      // if(this.$refs['carparkFilter'].filterValue) {
      //   url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      // }
      url += '/customer/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageCustomer = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicense() {
      let feedbackItem = 'license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.loadInvoice();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadInvoice() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'invoice';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      // url += '&startDate=' + moment().startOf('day').unix() + '&endDate=' + moment().endOf('day').unix()
      // url += '&startDate=' + moment().startOf('day').unix() + '&endDate=' + moment().endOf('day').unix()

      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageInvoice = response.data;
            this.loadInvoiceLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadInvoiceLease() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'bill detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoiceLease?1=1';
      // if(this.$refs['licenseFilter'].filterValue) {
      //   url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      // }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageInvoiceLease = response.data;
            this.loadDebitNoteLease();
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          // }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadDebitNoteLease() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'bill detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/dnLease?1=1';
      // if(this.$refs['licenseFilter'].filterValue) {
      //   url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      // }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageDebitNoteLease = response.data;
            this.loadCreditNoteLease();
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          // }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCreditNoteLease() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'bill detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/cnLease?1=1';
      // if(this.$refs['licenseFilter'].filterValue) {
      //   url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      // }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageCreditNoteLease = response.data;
            this.processData();
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          // }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    processData() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let leaseGroup = {};

      let paidCustomer = {};

      for(let index in this.pageInvoice) {
        let k = this.pageInvoice[index];
        let invoice = k;

        if(k['voidDate']) {
          continue;
        }

        try {
          k['_dataRef'] = JSON.parse(k['dataRef']);
        } catch(e) {
          continue;        
        }

        if(!k['dataRef']) {
          continue;
        }

        let billingDate = k['_dataRef'].billingDate;
        if(!billingDate) {
          continue;
        }

        if(billingDate < startDate.unix() || billingDate > endDate.unix()) {
          continue;
        }

        if(billingDate < startDate.unix() || billingDate > endDate.unix()) {
          continue;
        }

        if(k.type !== 'INIT Fee INV' 
        && k.type !== 'Monthly Fee INV'
        && k.type !== 'Increase Fee DN'
        && k.type !== 'Decrease Fee CN'
        && k.type !== 'Rev Monthly Fee CN'
        ) {
          continue;
        };

        if(k.billType === 'INV') {
          let invoiceLease = this.pageInvoiceLease.filter(j => j.invoiceID === k.id);
          for(let invoiceLeaseDetail of invoiceLease) {
            let customerID = k.customerID;
            let key = customerID + '_' + invoiceLeaseDetail.seasonID;

            let tempCustomer = paidCustomer[key] = paidCustomer[key] || {};
            let temp = tempCustomer[invoiceLeaseDetail.leaseID] = tempCustomer[invoiceLeaseDetail.leaseID] || {
              rate: 0,
              value: 0,
            }

            temp['customerID'] = k.customerID;
            temp['seasonID'] = invoiceLeaseDetail.seasonID;
            temp['leaseID'] = invoiceLeaseDetail.leaseID;
            temp['_customer'] = this.pageCustomer.find(j => j.id === customerID) || {};
            temp['isCompany'] = temp['_customer'].isCompany;
            temp['customerID'] = temp['_customer'].id;
            let carparkID = k.carparkID;
            temp['_carpark'] = this.pageCarpark.find(j => j.id === carparkID) || {};
            temp['_license'] = this.pageLicense.find(j => j.customerID === customerID && j.carparkID === carparkID) || {};
            temp['licenseID'] = temp['_license'].id;
            temp['_season'] = this.pageSeason.find(j => j.id === invoiceLeaseDetail.seasonID)
            
            temp['parkinglicense'] = helper.plFormPLNum(temp['_license'].licenseOperatorNum, carparkID);
            temp['customer'] = temp['_customer']['name'];
            temp['season'] = temp['_season']['name'];
            temp['seasonTenant'] = temp['_season']['isTenant'] ? 'T' : 'NT';

            if(helper.compareID(temp['_season']['bayType'], 2)) {
              temp['seasonType'] = 'Reserved';
            } else if(helper.compareID(temp['_season']['bayType'], 3)) {
              temp['seasonType'] = 'Tandem-Reserved';
            } else if(helper.compareID(temp['_season']['bayType'], 1)) {
              temp['seasonType'] = 'Non-Reserved';
            } else if(helper.compareID(temp['_season']['bayType'], 4)) {
              temp['seasonType'] = 'Motorcycle';
            }

            // temp[temp['seasonType'] + ' passcard'] += invoiceLeaseDetail.passcardID ? 1 : 0;
            if(invoice.billType === 'INV') {
              let billingDateMoment = helper.parseDateTime(billingDate);
              if(billingDateMoment.date() !== 1) {
                temp['rate'] = invoiceLeaseDetail.inclusive / (billingDateMoment.daysInMonth() - billingDateMoment.date() + 1) * billingDateMoment.daysInMonth();
              } else {
                temp['rate'] = invoiceLeaseDetail.inclusive;
              }
            }
            
            temp['value'] = invoiceLeaseDetail.inclusive;
          }
        } else if(k.billType === 'DN') {
          let debitNoteLease = this.pageDebitNoteLease.filter(j => j.invoiceID === k.id);
          for(let invoiceLeaseDetail of debitNoteLease) {
            let customerID = k.customerID;
            let key = customerID + '_' + invoiceLeaseDetail.seasonID;

            let tempCustomer = paidCustomer[key]
            if(!tempCustomer) {
              continue;
            }
            let temp = tempCustomer[invoiceLeaseDetail.leaseID]
            if(!temp) {
              continue;
            }

            let billingDateMoment = helper.parseDateTime(billingDate);
            if(billingDateMoment.date() !== 1) {
              temp['rate'] += invoiceLeaseDetail.inclusive / (billingDateMoment.daysInMonth() - billingDateMoment.date() + 1) * billingDateMoment.daysInMonth();
            } else {
              temp['rate'] += invoiceLeaseDetail.inclusive;
            }

            temp['value'] += invoiceLeaseDetail.inclusive;
          }
        } else if(k.billType === 'CN') {
          let creditNoteLease = this.pageCreditNoteLease.filter(j => j.invoiceID === k.id);
          for(let invoiceLeaseDetail of creditNoteLease) {
            let customerID = k.customerID;
            let key = customerID + '_' + invoiceLeaseDetail.seasonID;

            let tempCustomer = paidCustomer[key]
            if(!tempCustomer) {
              continue;
            }
            let temp = tempCustomer[invoiceLeaseDetail.leaseID]
            if(!temp) {
              continue;
            }

            let billingDateMoment = helper.parseDateTime(billingDate);
            if(billingDateMoment.date() !== 1) {
              temp['rate'] -= invoiceLeaseDetail.inclusive / (billingDateMoment.daysInMonth() - billingDateMoment.date() + 1) * billingDateMoment.daysInMonth();
            } else {
              temp['rate'] -= invoiceLeaseDetail.inclusive;
            }
            
            temp['value'] -= invoiceLeaseDetail.inclusive;
          }
        }
      }

      let result = {};
      Object.keys(paidCustomer).forEach(k => {
        let subscriptionList = paidCustomer[k];
        
        for(let subscriptionKey in subscriptionList) {
          let subscription = subscriptionList[subscriptionKey];

          if(subscription.rate === 0 || subscription.value === 0) {
            continue;
          }

          let key = subscription.customerID + '_' + subscription.seasonID + '_' + subscription.rate;
          if(!result[key]) {
            result[key] = {
              'Reserved subscription': [],
              'Reserved passcard': 0,
              'Reserved rate': 0,
              'Reserved value': 0,
              'Tandem-Reserved subscription': [],
              'Tandem-Reserved passcard': 0,
              'Tandem-Reserved rate': 0,
              'Tandem-Reserved value': 0,
              'Non-Reserved subscription': [],
              'Non-Reserved passcard': 0,
              'Non-Reserved rate': 0,
              'Non-Reserved value': 0,
              'Motorcycle subscription': [],
              'Motorcycle passcard': 0,
              'Motorcycle rate': 0,
              'Motorcycle value': 0,
              'total subscription': [],
              'total passcard': 0,
              'total value': 0,
            };
            for(let x in subscription) {
              result[key][x] = subscription[x]
            }
          }
          let temp = result[key];

          if(!temp[subscription['seasonType'] + ' subscription'].includes(subscription.leaseID)) {
            temp[subscription['seasonType'] + ' subscription'].push(subscription.leaseID);
          }
          temp[subscription['seasonType'] + ' passcard'] = temp[subscription['seasonType'] + ' subscription'].length
          temp[subscription['seasonType'] + ' rate'] = subscription.rate;
          temp[subscription['seasonType'] + ' value'] += subscription.value;

          if(!temp['total subscription'].includes(subscription.leaseID)) {
            temp['total subscription'].push(subscription.leaseID);
          }
          temp['total passcard'] = temp['total subscription'].length
          temp['total value'] += subscription.value;
        }
      });

      result = Object.keys(result).map(k => {
        for(let field of Object.keys(result[k])) {
          if(field.endsWith('rate') || field.endsWith('value')) {
            result[k][field] = helper.formatMoney(result[k][field]);
          }
        }
        return result[k]
      });
      this.$refs['pageTable'].setTableData(result);
      if(result && result.length > 0) {
        this.showExportCSV = true;
      }
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadInvoice();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
        formData['staffNo'] = staff['personnelCode'];
      }
    },

    onCSVButtonClick() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      var header = [];
      if(carpark) {
        header.push('Car Park Code: ' + carpark.carparkCode)
        header.push('Car Park: ' + carpark.name)
      }
      header.push('REPORT : Customer Fees FOR THE MONTH - ' + (startDate.month() + 1) + '/' + startDate.year())

      printCSV('#jt-table', `Report Customer Fees ${(startDate.month() + 1) + '/' + startDate.year()}`, header);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCustomerFees.vue